import React from "react";
import { useGame } from "@empirica/core/player/classic/react";
import { NoAIControlInstructions } from "./NoAIControlInstructions.jsx";
import { ControlInstructions } from "./ControlInstructions.jsx";
import { AIDiscussInstructions } from "./AIDiscussInstructions.jsx";
import { StoryNogroupInstructions } from "./StoryNogroupInstructions.jsx";
import { FourTaskPilotInstructions } from "./FourTaskPilotInstructions.jsx";
import {
  isFourTaskPilotCondition,
  isStoryNogroupCondition,
} from "../utils/conditionUtils.js";

export function Introduction({ next }) {
  const game = useGame();
  const treatment = game.get("treatment") || {};
  const treatmentType = treatment.treatmentType;

  if (isFourTaskPilotCondition(treatment)) {
    return <FourTaskPilotInstructions next={next} />;
  }

  // Story nogroup conditions get their own individual-framed instructions
  const isStoryNogroup = isStoryNogroupCondition(treatment);
  if (isStoryNogroup) {
    return <StoryNogroupInstructions next={next} />;
  }

  const isAIDiscuss =
    treatmentType === "AI-Discuss" || treatmentType === "Synthetic Peers";

  // Render appropriate instructions based on treatment type
  if (treatmentType === "No-AI Control") {
    return <NoAIControlInstructions next={next} />;
  } else if (treatmentType === "Control" || treatmentType === "nogroup") {
    return <ControlInstructions next={next} />;
  } else if (isAIDiscuss) {
    return <AIDiscussInstructions next={next} />;
  }

  // Fallback to default instructions if treatment type is not recognized
  return <ControlInstructions next={next} />;
}
